const r = {
  primary: "'PrimaryFont', 'Nunito Sans', sans-serif",
  secondary: "'SecondaryFont', 'Lora', serif"
};
export {
  r as FONT
};
//# sourceMappingURL=font.es.js.map
